<template>
    <div class="minisite-divide" :style="getDivideStyle">
        <template-00 v-if="listStyle.templateId === '00'" :data="data"></template-00>
    </div>
</template>

<script>
    import CommonMixIn from './common.mixin'
    import DivideTemplate from './divide'

    export default {
        name: "Divide",
        mixins: [CommonMixIn],
        props: {
        },
        components: {
            'template-00': DivideTemplate.Template00,
        },
        computed: {
            listStyle() {
                return this.data.style
            },
            getDivideStyle() {
                if (this.data.style && this.data.style.background) {
                    return Object.assign(
                        {},
                        this.getBackground(this.data.style.background),
                        this.getPadding(this.data.style.background.padding),
                        this.getMargin(this.data.style.background.margin)
                    )
                }
                return {}
            }
        }

    }
</script>

<style lang="less" scoped>

    .minisite-divide {
        width: 100%;
    }

</style>
